export default () => {
//   const primaryMenu = document.querySelector("#primary-menu");
//   if (!primaryMenu) {
//     return;
//   }

//   const menuItems = primaryMenu.querySelectorAll("li.menu-item.menu-item-has-children > a[href='#']");
//   for (const item of menuItems) {
//     item.addEventListener("click", (e) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const submenu = item.parentElement.querySelector("ul.sub-menu");
//       if (!submenu) {
//         return;
//       }

//       item.parentElement.classList.toggle("ast-submenu-expanded");

//       if (submenu.style.display === "none") {
//         submenu.style.display = "block";
//       } else {
//         submenu.style.display = "none";
//       }
//     });
//   }
}
